import KeyWords from './key-words';

export default class KeyWordsDesktop extends KeyWords {
    constructor(...args) {
        super(...args);
    }

    /*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// ./src/js/components/key-words/key-words.desktop.js